import { createSlice } from "@reduxjs/toolkit";

import { getMyProfile } from "./profileAPI";

const initialState = {
  status: "idle",
  error: null,
  username: null,
  name: null,
  roles: [],
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.status = "loading";
      state.error = null;
    },
    setProfile: (state, action) => {
      const profile = action.payload ?? {};
      state.status = "succeeded";
      state.error = null;
      state.username = profile.username ?? null;
      state.name = profile.name ?? profile.username ?? null;
      state.roles = profile.roles ?? [];
    },
    setError: (state) => {
      state.status = "failed";
      state.error = "Could not load your profile.";
    },
    clearProfile: () => initialState,
  },
});

export const { setLoading, setProfile, setError, clearProfile } = profileSlice.actions;
export const selectProfile = (state) => state.profile ?? initialState;

export const handleGetMyProfile = () => async (dispatch) => {
  dispatch(setLoading());
  try {
    const response = await getMyProfile();
    dispatch(setProfile(response.data));
  } catch (_) {
    dispatch(setError());
  }
};

export default profileSlice.reducer;
